/*
 * Author: Roger
 * File Created: Thursday, 25-06-26 07:16 pm
 * Last Modified: Tuesday, 25-07-22 10:25 am, by Dw
 */

export const base64ToBlobFile = (
  base64: string,
  mimeType: string,
  filename: string
): File => {
  const base64WithoutPrefix = base64.startsWith('data:image/png;base64,')
    ? base64.slice('data:image/png;base64,'.length)
    : base64; // 如果有前缀，则去掉前缀
  const byteString = atob(base64WithoutPrefix); // 将 base64 数据转换为二进制数据
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: mimeType });
  const file = new File([blob], filename, { type: 'image/png' });
  return file;
};

export const fetchImage = (url: string): Promise<boolean> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = url;

    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
  });
};
